import React from "react";
import {
  Box,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  History as HistoryIcon,
} from "@mui/icons-material";
import PlayerSessions from "../_sharedSections/PlayerSessions";

export default function Sessions() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ py: { xs: 2, md: 4 } }}>
      {/* Header Section */}
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography 
          variant={isMobile ? "h4" : "h3"} 
          component="h1" 
          gutterBottom 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            gap: 2,
            color: 'primary.main',
            fontWeight: 600
          }}
        >
          <HistoryIcon color="primary" fontSize={isMobile ? "large" : "inherit"} />
          Session History
        </Typography>
        <Typography 
          variant="body1" 
          color="textSecondary"
          sx={{ maxWidth: 600, mx: 'auto' }}
        >
          View your poker game session history and statistics
        </Typography>
      </Box>

      {/* Sessions Content */}
      <PlayerSessions />
    </Box>
  );
}
